module.exports = __webpack_public_path__ + "img/regulation-2.ae8943e5.svg";